import { useState, useEffect } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Hook para buscar contagens mensais de agendamentos a partir de agregadoAgendamentos.
 * Usa quantidadeTotal de cada documento mensal (formato ID: YYYY-MM).
 */
export const useAppointmentsMonthlyAggregate = () => {
  const [monthlyAggregates, setMonthlyAggregates] = useState([]);
  const [availableYears, setAvailableYears] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    const appointmentsAggregatesCollection = collection(db, 'agregadoAgendamentos');

    const unsubscribe = onSnapshot(
      appointmentsAggregatesCollection,
      (aggregatesSnapshot) => {
        try {
          const aggregates = [];
          const yearsSet = new Set();

          aggregatesSnapshot.forEach((aggregateDoc) => {
            const data = aggregateDoc.data();
            const appointmentsArray = data.appointments || [];

            let year = data.ano;
            let month = data.mes;

            if (!year || !month) {
              const match = aggregateDoc.id.match(/^(\d{4})-(\d{2})$/);
              if (match) {
                year = parseInt(match[1], 10);
                month = parseInt(match[2], 10);
              }
            }

            if (!year || !month) return;

            const count =
              typeof data.quantidadeTotal === 'number'
                ? data.quantidadeTotal
                : appointmentsArray.length;

            aggregates.push({
              monthKey: aggregateDoc.id,
              year,
              month,
              count,
            });

            if (count > 0) {
              yearsSet.add(year);
            }
          });

          aggregates.sort((a, b) => {
            if (a.year !== b.year) return b.year - a.year;
            return b.month - a.month;
          });

          setMonthlyAggregates(aggregates);
          setAvailableYears(Array.from(yearsSet).sort((a, b) => b - a));
          setLoading(false);
        } catch (err) {
          setError(err);
          setLoading(false);
        }
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return { monthlyAggregates, availableYears, loading, error };
};
